import type { TemplateListApiArg } from '@/services/api/generated/templatesV2Service';

/**
 * Filter state for the templates DataTable.
 * Maps directly to TemplateListApiArg query parameters.
 */
export interface TemplateFilterState {
  search: string;
  // Legacy single-select fields (used by older templates-v2 components).
  category: TemplateListApiArg['category'] | undefined;
  format: TemplateListApiArg['templateFormat'] | undefined;
  firmId: string | undefined;
  // Multi-select fields (used by operator table/page).
  categories: NonNullable<TemplateListApiArg['category']>[];
  formats: NonNullable<TemplateListApiArg['templateFormat']>[];
  scope: TemplateListApiArg['scope'] | undefined;
  status: TemplateListApiArg['status'] | undefined;
  isDefault: boolean | undefined;
  firmIds: string[];
}

export const DEFAULT_FILTER_STATE: TemplateFilterState = {
  search: '',
  category: undefined,
  format: undefined,
  firmId: undefined,
  categories: [],
  formats: [],
  scope: undefined,
  status: 'ACTIVE',
  isDefault: undefined,
  firmIds: [],
};

export interface TemplatePaginationState {
  limit: number;
  offset: number;
}

export const DEFAULT_PAGINATION: TemplatePaginationState = {
  limit: 50,
  offset: 0,
};
